module.exports = __webpack_public_path__ + "static/media/groov-round-logo.9d1be44a.svg";